
/** @type{Record<string, typeof import('pict-provider')>} */
const providers = {};
providers.BridgeDisplay = require('./providers/PictProvider-InputType-BridgeDisplay.js');
providers.BridgeSelector = require('./providers/PictProvider-InputType-BridgeSelector.js');
providers['Bulma-HTML'] = require('./providers/PictProvider-Bulma-HTML.js');
providers['Bulma-Markdown'] = require('./providers/PictProvider-Bulma-Markdown.js');
// InputType MarkdownDisplay: the value-bound sibling of Markdown, for a remark a user typed.
providers['Bulma-MarkdownDisplay'] = require('./providers/PictProvider-Bulma-MarkdownDisplay.js');
providers['Bulma-MaterialsQRCodeDisplay'] = require('./providers/PictProvider-Bulma-MaterialsQRCodeDisplay.js');
providers['Bulma-TableControls'] = require('./providers/PictProvider-Bulma-TableControls.js');
providers['Bulma-RecordSetControls'] = require('./providers/PictProvider-Bulma-RecordSetControls.js');
providers.DataTypeDatePicker = require('./providers/PictProvider-DataType-DatePicker.js');
providers.DataTypeDateTimePicker = require('./providers/PictProvider-DataType-DateTimePicker.js');
providers.DataTypeTimePicker = require('./providers/PictProvider-DataType-TimePicker.js');
providers.DatePickerProvider = require('./providers/PictProvider-DataType-DatePicker.js');
providers.DateTimePickerProvider = require('./providers/PictProvider-DataType-DateTimePicker.js');
providers.DraggableUtil = require('./providers/PictProvider-DraggableUtil.js');
providers.EmailAddressProvider = require('./providers/PictProvider-InputType-EmailAddress.js');
providers.EntityBundleClient = require('./providers/PictProvider-EntityBundleClient.js');
providers.FlatpickrUtilProvider = require('./providers/PictProvider-FlatpickrUtil.js');
providers.InputValidation = require('./providers/PictProvider-InputValidation.js');
providers.ChipTooltips = require('./providers/PictProvider-ChipTooltips.js');
providers.NumberScrollLock = require('./providers/PictProvider-NumberScrollLock.js');
providers.LabDisplay = require('./providers/PictProvider-InputType-LabDisplay.js');
providers.LabSelector = require('./providers/PictProvider-InputType-LabSelector.js');
providers.SampleTypeSelector = require('./providers/PictProvider-InputType-SampleTypeSelector.js');
providers.LineItemDisplay = require('./providers/PictProvider-InputType-LineItemDisplay.js');
providers.LineItemSelector = require('./providers/PictProvider-InputType-LineItemSelector.js');
providers.GeolocationSelector = require('./providers/PictProvider-InputType-GeolocationSelector.js');
providers.MaterialDisplay = require('./providers/PictProvider-InputType-MaterialDisplay.js');
providers.MaterialSelector = require('./providers/PictProvider-InputType-MaterialSelector.js');
providers.MixSpecificationDisplay = require('./providers/PictProvider-InputType-MixSpecificationDisplay.js');
providers.MixSpecificationSelector = require('./providers/PictProvider-InputType-MixSpecificationSelector.js');
providers.ObservationCardDeckProvider = require('./providers/PictProvider-InputType-ObservationCardDeck.js');
providers.ObservationTypeDisplay = require('./providers/PictProvider-InputType-ObservationTypeDisplay.js');
providers.ObservationTypeSelector = require('./providers/PictProvider-InputType-ObservationTypeSelector.js');
providers.PhoneNumberProvider = require('./providers/PictProvider-InputType-PhoneNumber.js');
providers.PhysicalAssetSelector = require('./providers/PictProvider-InputType-PhysicalAssetSelector.js');
providers.PlantDisplay = require('./providers/PictProvider-InputType-PlantDisplay.js');
providers.PlantSelector = require('./providers/PictProvider-InputType-PlantSelector.js');
providers.FileSelector = require('./providers/PictProvider-InputType-FileSelector.js');
providers.PrecompiledFileSelector = require('./providers/PictProvider-InputType-PrecompiledFileSelector.js');
providers.ObservationPhoto = require('./providers/PictProvider-InputType-ObservationPhoto.js');
providers.ProducerDisplay = require('./providers/PictProvider-InputType-ProducerDisplay.js');
providers.ProducerSelector = require('./providers/PictProvider-InputType-ProducerSelector.js');
providers.ProductDisplay = require('./providers/PictProvider-InputType-ProductDisplay.js');
providers.ProductSelector = require('./providers/PictProvider-InputType-ProductSelector.js');
providers.EntityDisplay = require('./providers/PictProvider-InputType-EntityDisplay.js');
providers.EntitySelector = require('./providers/PictProvider-InputType-EntitySelector.js');
providers.EntityDisplayMultiple = require('./providers/PictProvider-InputType-EntityDisplayMultiple.js');
providers.EntitySelectorMultiple = require('./providers/PictProvider-InputType-EntitySelectorMultiple.js');
// pict-section-picker: the widget provider + the select2-free 'Picker' InputType (a Headlight subclass
// of the module's form-input adapter that adds project + spec-year scoping). Replaces EntitySelectorMultiple.
providers['Pict-Section-Picker'] = require('pict-section-picker');
providers.Picker = require('./providers/PictProvider-InputType-Picker.js');
// Unified test acceptance — the Picker-stack replacement for the legacy SampleTestResult select, plus
// the disclosure that shows its sibling RichText remarks field.
providers.SampleTestAcceptance = require('./providers/PictProvider-InputType-SampleTestAcceptance.js');
// Complex-editor InputTypes from pict-section-form. PSF exports these provider classes but does NOT
// auto-register them (their heavy editor deps are opt-in), so the bundle registers them here under the
// exact hashes the templates' DefaultInputExtensions reference. Each is a Headlight subclass adding the
// inline View/Edit presentation behavior.
// @ts-ignore - subclasses of an external provider class, same shape the Picker registration above has
providers['Pict-Input-Diagram'] = require('./providers/PictProvider-InputType-Diagram.js');
// @ts-ignore
providers['Pict-Input-RichText'] = require('./providers/PictProvider-InputType-RichText.js');
// PickerDisplay: the non-interactive Read/Print display for 'Picker' (resolves value -> label / entity name).
providers.PickerDisplay = require('./providers/PictProvider-InputType-PickerDisplay.js');
// The MaterialsEntitySelector cascade ports, each named by its wave's port-forward template. Each @ts-ignore
// below suppresses the same pict-provider static-identity mismatch the 'Picker' registration above carries.
// @ts-ignore — wave 5: SampleType cascade
providers.SampleTypePicker = require('./providers/PictProvider-InputType-SampleTypePicker.js');
// @ts-ignore — shared cascade base (waves 6-9)
providers.MaterialsCascadePicker = require('./providers/PictProvider-InputType-MaterialsCascadePicker.js');
// @ts-ignore — wave 6: Sample hub
providers.MaterialsSamplePicker = require('./providers/PictProvider-InputType-MaterialsSamplePicker.js');
// @ts-ignore — wave 7: Test driver (save-projection)
providers.MaterialsTestPicker = require('./providers/PictProvider-InputType-MaterialsTestPicker.js');
// @ts-ignore — wave 8: Lab join
providers.MaterialsLabPicker = require('./providers/PictProvider-InputType-MaterialsLabPicker.js');
// @ts-ignore — wave 8: LineItem join
providers.MaterialsLineItemPicker = require('./providers/PictProvider-InputType-MaterialsLineItemPicker.js');
// @ts-ignore — wave 8: Test-Lab join
providers.MaterialsTestLabPicker = require('./providers/PictProvider-InputType-MaterialsTestLabPicker.js');
// @ts-ignore — wave 9: Test injector (__Record opt-out)
providers.MaterialsTestInjectorPicker = require('./providers/PictProvider-InputType-MaterialsTestInjectorPicker.js');
// @ts-ignore — wave 10: the base MaterialsEntitySelector (descriptor-named Entity)
providers.MaterialsEntityPicker = require('./providers/PictProvider-InputType-MaterialsEntityPicker.js');
// @ts-ignore — SampleStatus vocabulary port (managed code list + the test-result status derivation)
providers.SampleStatusPicker = require('./providers/PictProvider-InputType-SampleStatusPicker.js');
// wave 9: Sample Read/Print display (PickerDisplay + QR-image prepend)
providers.MaterialsSamplePickerDisplay = require('./providers/PictProvider-InputType-MaterialsSamplePickerDisplay.js');
providers.MaterialsEntitySelector = require('./providers/PictProvider-InputType-MaterialsEntitySelector.js');
providers.MaterialsEntityDisplay = require('./providers/PictProvider-InputType-MaterialsEntityDisplay.js');
providers.MaterialsSampleSelector = require('./providers/PictProvider-InputType-MaterialsSampleSelector.js');
providers.MaterialsSampleDisplay = require('./providers/PictProvider-InputType-MaterialsSampleDisplay.js');
providers.MaterialsTestInjector = require('./providers/PictProvider-InputType-MaterialsTestInjector.js');
providers.MaterialsTestSectionRemover = require('./providers/PictProvider-InputType-MaterialsTestSectionRemover.js');
providers.MaterialsTestSelector = require('./providers/PictProvider-InputType-MaterialsTestSelector.js');
providers.MaterialsTestDisplay = require('./providers/PictProvider-InputType-MaterialsTestDisplay.js');
providers.MaterialsLineItemSelector = require('./providers/PictProvider-InputType-MaterialsLineItemSelector.js');
providers.MaterialsLabSelector = require('./providers/PictProvider-InputType-MaterialsLabSelector.js');
providers.MaterialsTestLabSelector = require('./providers/PictProvider-InputType-MaterialsTestLabSelector.js');
providers.MaterialsPlantSelector = require('./providers/PictProvider-InputType-MaterialsPlantSelector.js');
providers.MaterialsLabDisplay = require('./providers/PictProvider-InputType-MaterialsLabDisplay.js');
providers.MaterialsLineItemDisplay = require('./providers/PictProvider-InputType-MaterialsLineItemDisplay.js');
providers.SampleStatusSelector = require('./providers/PictProvider-InputType-SampleStatusSelector.js');
providers.SampleTestResult = require('./providers/PictProvider-InputType-SampleTestResult.js');
providers.ProjectDisplay = require('./providers/PictProvider-InputType-ProjectDisplay.js');
providers.ProjectSelector = require('./providers/PictProvider-InputType-ProjectSelector.js');
providers.QRCode = require('./providers/PictProvider-QRCode.js');
providers.ResponsiveUIAdjustmentProvider = require('./providers/PictProvider-ResponsiveUIAdjustment.js');
providers.SampleDisplay = require('./providers/PictProvider-InputType-SampleDisplay.js');
providers.SampleSelector = require('./providers/PictProvider-InputType-SampleSelector.js');
// EntityFilterEngine: the Headlight filter-composition engine extracted from Select2Util (which now
// extends it). Registered on its own so the pict-section-picker 'Picker' broker can call it directly.
providers.EntityFilterEngine = require('./providers/PictProvider-EntityFilterEngine.js');
providers.Select2Util = require('./providers/PictProvider-Select2Util.js');
providers.SpecScopeResolver = require('./providers/PictProvider-SpecScopeResolver.js');
providers.ThroughScopeResolver = require('./providers/PictProvider-ThroughScopeResolver.js');
providers.LabScopeResolver = require('./providers/PictProvider-LabScopeResolver.js');
providers.Station = require('./providers/PictProvider-InputType-Station.js');
providers.TimePickerProvider = require('./providers/PictProvider-DataType-TimePicker.js');
providers.MediaRegistry = require('./providers/PictProvider-MediaRegistry.js');
// MediaDetailCards provider removed — InputType now routes through ObservationCardDeckProvider via template redirect and patchedConfiguration.
providers.SignatureProvider = require('./providers/PictProvider-InputType-Signature.js');
providers.TextAreaProvider = require('./providers/PictProvider-InputType-TextArea.js');
providers.DistillingBundleManager = require('./providers/Pict-Provider-DistillingBundleManager.js');
providers.DistilledInput = require('./providers/Pict-Provider-Input-DistilledInput.js');
providers.DataRequirementsProvider = require('./providers/PictProvider-DataRequirements.js');
// NOTE: We have to 'override' the default Select provider to make trigger groups work since it's hardcoded to `Pict-Input-Select` in the trigger logic
providers['Pict-Input-Select'] = require('./providers/PictProvider-InputType-Select.js');
// Tier-2.5 a11y: Read/Print-theme static-display painter for the Color input, whose locked
// state can't use the `readonly` attribute. Paints a swatch + hex into the display node;
// no-op when that node is absent (Edit theme).
providers['Pict-Input-Color'] = require('./providers/PictProvider-InputType-Color.js');
providers['Pict-Input-TabGroupSelector'] = require('./providers/PictProvider-InputType-TabGroupSelector.js');
providers['Pict-Input-TabSectionSelector'] = require('./providers/PictProvider-InputType-TabSectionSelector.js');

/**
 * @typedef {Object} ThemeProvider
 * @property {String} TemplatePrefix - The template prefix for the theme.
 * @property {Array<Object>} Templates - The templates for the theme.
 * TODO: this is probably incomplete, and definitely not living in the right place; move this eventually
 */

/** @type {Record<string, ThemeProvider>} */
const themes = { };
themes.Base = require('./themes/PictProvider-Theme-Base.js');
themes.Edit = require('./themes/PictProvider-Theme-Edit.js');
themes.Read = require('./themes/PictProvider-Theme-Read.js');
themes.Print = require('./themes/PictProvider-Theme-Print.js');
// Body markup for the Geolocation input types, assembled per presentation by {~GeolocationBody:~}.
const libGeolocationBodies = require('./templates/GeolocationBodies.js');
// Body markup for the Diagram / RichText editor input types, assembled per presentation by {~EditorBody:~}.
const libEditorBodies = require('./templates/EditorBodies.js');
// Target/rel attribute resolution for the Link input type, emitted per anchor by {~LinkTarget:~}.
const libLinkTarget = require('./providers/PictProvider-Template-LinkTarget.js');

const libFilterToggleUI = require('./providers/_FilterToggleUI.js');

/**
 * Escape a value for safe use in both an HTML attribute (double-quoted) and an element text node.
 * @param {any} pValue
 * @return {string}
 */
function escapeHTML(pValue)
{
	return String(pValue == null ? '' : pValue).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/**
 * The first of pKeys set on a PictForm block, as an HTML attribute; '' when none is set.
 * @param {Record<string, any>} pPictForm
 * @param {Array<string>} pKeys - PictForm keys in priority order.
 * @param {string} pAttribute - The HTML attribute name.
 * @return {string}
 */
function pictFormAttribute(pPictForm, pKeys, pAttribute)
{
	const tmpKey = pKeys.find((pKey) => pPictForm && pPictForm[pKey] !== undefined && pPictForm[pKey] !== null && pPictForm[pKey] !== '');
	return tmpKey ? `${pAttribute}="${escapeHTML(pPictForm[tmpKey])}"` : '';
}

/** @type {Record<string, typeof import('pict-view')>} */
const views = {};
views.FormHeader = require('./views/PictView-FormHeader.js');
views.TestResultsSummary = require('./views/PictView-TestResultsSummary.js');
// @ts-ignore
views.GeolocationSelector = require('./views/PictView-GeolocationSelector.js');

// inject all the templates for the themed views
const themedTemplatesList = require('./templates/_index.js');
for (const template of themedTemplatesList)
{
	for (const [ themeKey, themeTemplate ] of Object.entries(template))
	{
		if (!themes[themeKey])
		{
			themes[themeKey] = {
				TemplatePrefix: 'PictProvider-Theme-' + themeKey,
				Templates: [],
			};
		}
		themes[themeKey].Templates.push(...themeTemplate);
	}
}

class HeadlightDynamicInputsBundle
{
	static getProviderMap()
	{
		return providers;
	}

	static getViewMap()
	{
		return views;
	}

	static getThemeMap()
	{
		return themes;
	}

	/**
	 * The options to register a bundle provider with: the bundle's defaults for that provider, with any
	 * app-supplied option winning. Every registration path must go through this so the defaults apply.
	 *
	 * @param {string} pKey - The provider key from getProviderMap().
	 * @param {Record<string, any>} [pOptions] - App-supplied options for that provider.
	 * @return {Record<string, any>}
	 */
	static getProviderOptions(pKey, pOptions = { })
	{
		// One dropdown open at a time (select2 parity), fleet-wide.
		if (pKey === 'Pict-Section-Picker')
		{
			return Object.assign({ SingleActivePicker: true }, pOptions);
		}
		return pOptions;
	}

	/**
	 * @param {import('pict')} pict
	 */
	constructor(pict)
	{
		this.pict = pict;
	}

	attach(providerOptionsMap = { }, viewOptionsMap = { })
	{
		this.attachProviders(providerOptionsMap);
		this.attachInstructions();
		this.attachViews(viewOptionsMap);
		this.injectThemes();
	}

	attachProviders(providerOptionsMap = { })
	{
		for (const [ key, provider ] of Object.entries(providers))
		{
			this.pict.addProvider(key, HeadlightDynamicInputsBundle.getProviderOptions(key, providerOptionsMap[key] || { }), provider);
		}
	}

	attachViews(viewOptionsMap = { })
	{
		for (const [ key, view ] of Object.entries(views))
		{
			this.pict.addView(key, viewOptionsMap[key] || { }, view);
		}
	}

	injectThemes()
	{
		for (const templateSet of Object.values(themes))
		{
			this.pict.providers.PictFormSectionDefaultTemplateProvider.injectTemplateSet(templateSet);
		}
	}

	attachInstructions()
	{
		// create a label, but also account for extra inline tags, if they exist
		// NOTE: We do this here so that the "label" and any extra tags are all in same
		//	    flex container, so that they can be balanced properly
		this.pict.MetaTemplate.addPattern('{~LabelWithChips:', '~}', (pHash, pData) =>
		{
			// we need to first build the actual label content
			const labelContentTag = `<span${pData.PictForm.Required ? ' class="is-required"' : ''}>${pData.Name}</span>`;
			// if no data or chips, return the label string value
			if (!pData?.PictForm?.Chips) return labelContentTag;
			// if there are chips, build them
			const chips = {};
			// ignore the "Units" chip, as it's handled separately
			// TODO: Remove the script that puts "Units" in the chips object once we're sure it's not needed anymore
			for (const chipKey in pData.PictForm.Chips)
			{
				if (chipKey != 'Units')
				{
					chips[chipKey] = pData.PictForm.Chips[chipKey];
				}
			}
			// here's are basic chip map of known chips (icon, color)
			const chipMap = {
				'ExternalDatabaseID': {
					'icon': 'fa-database',
					'color': 'is-info',
				},
				'New': {
					'icon': 'fa-sparkles',
					'color': 'is-warning',
				},
			};
			// The chip value/id come from server data.
			let template = `<span class="chips">`;
			// todo: implement switch for TabularLabel if other tabular labels are needed
			// check hash for TabularLabel and add the appropriate template
			if (!pHash.includes('TabularLabel'))
			{
				template += `${ labelContentTag }`;
			}
			// Emit each chip as a self-contained, reflow-free anchor. The chip's
			// text lives in `.chip-label` (hidden on screen, revealed only in the
			// Print theme) and is mirrored in `data-chip-label` so the runtime
			// PictProvider-ChipTooltips can wire a pinnable tooltip to the anchor
			// without re-reading the DOM. No inline onclick / is-active here — the
			// provider owns hover + click-to-pin behavior and pin persistence.
			// eslint-disable-next-line guard-for-in
			for (const chipKey in chips)
			{
				const chipObject = {};
				// if it's a custom object, use it
				if (typeof pData.PictForm.Chips[chipKey] == 'object')
				{
					chipObject._id = chipKey;
					chipObject._value = pData.PictForm.Chips[chipKey].Value || pData.PictForm.Chips[chipKey].value || chipKey;
					// set the passed values, or use the map, or use the defaults
					chipObject.icon = pData.PictForm.Chips[chipKey].Icon || pData.PictForm.Chips[chipKey].icon || chipMap?.[chipKey]?.icon || 'fa-info';
					chipObject.color = pData.PictForm.Chips[chipKey].Color || pData.PictForm.Chips[chipKey].color || chipMap?.[chipKey]?.color || 'is-text';
				}
				else if (typeof pData.PictForm.Chips[chipKey] == 'string')
				{
					chipObject._id = chipKey;
					chipObject._value = pData.PictForm.Chips[chipKey];
					// check if it's in the chipMap and if so, use the icon and color (or defaults)
					chipObject.icon = chipMap?.[chipKey]?.icon || 'fa-info';
					chipObject.color = chipMap?.[chipKey]?.color || 'is-text';
				}
				else
				{
					// if it's not a string or object, we don't know what's going on, so skip it
					continue;
				}
				const tmpId = escapeHTML(chipObject._id);
				const tmpValue = escapeHTML(chipObject._value);
				const tmpIcon = escapeHTML(chipObject.icon);
				const tmpColor = escapeHTML(chipObject.color || '');
				template +=
				`<button type="button" class="chip ${tmpColor}"
					data-chip-for="${tmpId}"
					data-chip-label="${tmpValue}"
					data-chip-icon="${tmpIcon}"
					data-chip-color="${tmpColor}"
					aria-label="${tmpId}: ${tmpValue}">
					<span class="icon">
						<i class="fa fa-fw ${tmpIcon}"></i>
					</span>
					<span class="chip-label">${tmpValue}</span>
				</button>`;
			}
			// close the chips span
			template += '</span>';
			// check hash for TabularLabel and add the appropriate template
			if (pHash.includes('TabularLabel'))
			{
				template += `<span class="label">${ labelContentTag }</span>`;
			}
			return template;
		});

		// Start the runtime chip-tooltip wiring (idempotent). attachProviders()
		// runs before attachInstructions() in every host app, so the provider
		// exists here; it lazily wires any chip the MetaTemplate above emits.
		if (this.pict.providers.ChipTooltips && typeof this.pict.providers.ChipTooltips.start === 'function')
		{
			this.pict.providers.ChipTooltips.start();
		}

		this.pict.MetaTemplate.addPattern('{~UnitsAddon:', '~}', (pHash, pData, pContext) =>
		{
			// if there are no units, return an empty string
			const tmpUnits = pData.PictForm.Units || pData.PictForm.Chips?.Units || '';
			const isTabular = pData.IsTabular;
			// 'UseInlineUnits' for tabular/recordset contexts means to show the units next to the input, even in tabular mode
			const useInlineUnits = pData.PictForm?.UseInlineUnits;
			if (!tmpUnits) return '';
			// a table shows units in its column header; a record set has no header, so its units stay beside the field
			if (isTabular && !useInlineUnits && resolveGroupLayout(pData, pContext) !== 'RecordSet')
			{
				return '';
			}
			// if there are units, return the units. aria-hidden keeps the
			// decorative unit pill from being announced as a separate
			// interactive control (already conveyed by the label). (Tier 4)
			return `<p class="control control-status addon">
						<button tabindex="-1" aria-hidden="true" class="addon-button button is-static" type="button">${tmpUnits}</button>
					</p>`;
		});

		// TODO: Consider making Print an optional flag on the previous method
		this.pict.MetaTemplate.addPattern('{~UnitsAddonPrint:', '~}', (pHash, pData, pContext) =>
		{
			// if there are no units, return an empty string
			const tmpUnits = pData.PictForm.Units || pData.PictForm.Chips?.Units || '';
			const isTabular = pData.IsTabular;
			// 'UseInlineUnits' for tabular/recordset contexts means to show the units next to the input, even in tabular mode
			const useInlineUnits = pData.PictForm?.UseInlineUnits;
			if (!tmpUnits) return '';
			// a table shows units in its column header; a record set has no header, so its units stay beside the field
			if (isTabular && !useInlineUnits && resolveGroupLayout(pData, pContext) !== 'RecordSet')
			{
				return '';
			}
			// if there are units, return the units
			return `<span class="control">
				<div class="input is-static has-text-text-50 units-text">${tmpUnits}</div>
			</span>`;
		});

		this.pict.MetaTemplate.addPattern('{~UnitsTabularHeader:', '~}', (pHash, pData) =>
		{
			// if there are no units, return an empty string
			const tmpUnits = pData.PictForm.Units || pData.PictForm.Chips?.Units || '';
			const isTabular = pData.IsTabular;
			// 'UseInlineUnits' for tabular/recordset contexts means to show the units next to the input, even in tabular mode
			const useInlineUnits = pData.PictForm?.UseInlineUnits;
			if (!tmpUnits) return '';
			// if this is tabular and we are using inline units, don't return anything for the header on the table
			if (isTabular && useInlineUnits)
			{
				return '';
			}
			// if there are units, return the units
			return `<div class="tag has-text-centered is-block" style="line-height: 1.5rem">${tmpUnits}</div>`;
		});

		// add the required + aria-required attributes if the field is required.
		// The PictProvider-InputValidation runtime sync may later strip these
		// when the input becomes hidden (e.g. inactive tab) so that the
		// browser/framework's checkValidity() and assistive tech reflect what
		// the user can actually see.
		//
		// a11y tiers (tracked here): Tiers 1, 2, 2.5, 3 (Half A) and 4 are DONE,
		// as is Tier 5. See test/Templates-A11y-Tier2-*.{js,md},
		// test/Templates-A11y-Tier3-*.js and test/Templates-A11y-Tier4-*.js for
		// per-template coverage and the smoke checklist. (Tier 5 is runtime DOM
		// in PictProvider-InputValidation, so it has no string-level test here.)
		//   Tier 1 — aria-required / aria-disabled / aria-invalid / role=alert on validation-text /
		//     aria-describedby help-text pairing (PictProvider-InputValidation).
		//   Tier 2 — Read theme `disabled="disabled"` -> `readonly aria-readonly="true"` on text and
		//     number inputs (incl. Geolocation lat/long; its disableMap gate also treats readonly as
		//     locked). The locked look is preserved by the `[aria-readonly="true"]` rule in
		//     lib/web/headlight-styles/bulma-extended.scss.
		//   Tier 2.5 — non-text controls that can't use `readonly` present a static locked value:
		//     Option/Select2 render the selected LABEL into the DISPLAY-FOR node
		//     (PictProvider-InputType-Select); Boolean keeps a disabled checkbox (filled/empty, matches
		//     Print); Color paints a swatch + hex via PictProvider-InputType-Color in both Read and Print.
		//   Note (by design): the required-label "*" is a CSS ::after pseudo-element, not announced by
		//     mainstream screen readers; switch to an explicit aria-hidden span only if axe flags it.
		//   Note (carry-over): AJAX / dynamic-pick-list selects may show the raw id in the static view
		//     if PictForm.SelectOptions lacks the label (same gap the Print path already had).
		//
		//   Tier 3 (tab semantics) — Half A DONE, Half B intentionally skipped:
		//     Half A (shipped): <ul><li onclick> tab markup carries
		//       role="tablist" / role="presentation" / role="tab" + aria-selected,
		//       and each tab is wired to its panel via aria-controls <-> the
		//       panel's role="tabpanel" + aria-labelledby. The static roles live
		//       in the templates; the stateful aria-selected and the cross-element
		//       relationships (the panel id carries a runtime UUID/formID) are set
		//       in selectTabByViewHash, overridden in the local Tab*Selector
		//       providers. See: templates/InputType-TabSectionSelector.js,
		//            templates/InputType-TabGroupSelector.js,
		//            providers/PictProvider-InputType-Tab{Section,Group}Selector.js.
		//     Half B (NOT done, by decision): roving tabindex + arrow/Home/End
		//       key navigation. Skipped deliberately — tabs are already natively
		//       Tab/Shift+Tab focusable (WCAG 2.x keyboard-operable); roving
		//       tabindex would only trim Tab stops on long strips (ours are 3-5),
		//       and it requires a net-new keydown handler the team prefers to
		//       avoid for non-critical cases. Revisit only if long tab strips or
		//       a specific AT request makes the ergonomics worthwhile; it slots
		//       cleanly into the same provider override with no template churn.
		//
		//   Tier 4 (single-input edge cases) — DONE. See
		//     test/Templates-A11y-Tier4-IconLabels_tests.js.
		//     - Signature: aria-label on the modal drawing canvas + on the
		//       icon-only "edit" (pen) trigger buttons and the modal Undo/Redo
		//       buttons; alt text on every signature-preview <img>.
		//       See: templates/InputType-Signature.js,
		//            providers/PictProvider-InputType-Signature.js.
		//     - Tabular menus: aria-label on the icon-only row-actions ellipsis
		//       trigger; aria-hidden="true" on the decorative fa icons that sit
		//       beside visible text labels. See: templates/Tabular-Group.js.
		//     - aria-hidden="true" on the static-button units addon in
		//       {~UnitsAddon:~} above so the unit pill isn't read as a separate
		//       interactive control.
		//
		//   Tier 5 (richer announcements) — DONE.
		//     - aria-errormessage on the input pointing to the injected
		//       validation-text node's id (paired with the existing
		//       aria-invalid; cleared on every valid/hidden path). Lives in
		//       PictProvider-InputValidation alongside the validation-text
		//       injection in handleValidationHelpTextElementUpdate. Runtime DOM
		//       wiring, so no string-level test in this package.
		//
		// data-required="true" is the *persistent* marker — the manifest's
		// declaration of required-ness. The provider's runtime sync may flip
		// the `required` / `aria-required` attributes on/off as the field
		// becomes visible/hidden (e.g. tab switches), but data-required
		// stays put so we can restore the live attributes for fields that
		// re-appear, and so the pre-submit sweep can find every "ever
		// required" input across the form.
		this.pict.MetaTemplate.addPattern('{~Required:', '~}', (pHash, pData) =>
		{
			if (pData.PictForm.Required)
			{
				return 'required aria-required="true" data-required="true"';
			}
			return '';
		});

		// add the disabled + aria-disabled attributes if the field is disabled.
		// aria-disabled mirrors the native disabled state for assistive tech;
		// some screen readers don't announce native disabled consistently
		// across input variants, so emitting both belt-and-suspenders style.
		this.pict.MetaTemplate.addPattern('{~Disabled:', '~}', (pHash, pData) =>
		{
			if (pData.PictForm.Disabled)
			{
				return 'disabled aria-disabled="true"';
			}
			return '';
		});

		// Constraint attributes for native validation. Number templates take NumberMin / NumberMax / NumberStep, or
		// MinNumber / MaxNumber / StepNumber, which PictProvider-InputValidation also reads; text templates take
		// MinLength / MaxLength / Pattern.
		this.pict.MetaTemplate.addPattern('{~Min:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'NumberMin', 'MinNumber' ], 'min'));
		this.pict.MetaTemplate.addPattern('{~Max:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'NumberMax', 'MaxNumber' ], 'max'));
		this.pict.MetaTemplate.addPattern('{~Step:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'NumberStep', 'StepNumber' ], 'step') || 'step="any"');
		this.pict.MetaTemplate.addPattern('{~MinLength:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'MinLength' ], 'minlength'));
		this.pict.MetaTemplate.addPattern('{~MaxLength:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'MaxLength' ], 'maxlength'));
		this.pict.MetaTemplate.addPattern('{~Pattern:', '~}', (pHash, pData) => pictFormAttribute(pData.PictForm, [ 'Pattern' ], 'pattern'));

		// manage the placeholder string value at a consistent level
		this.pict.MetaTemplate.addPattern('{~Placeholder:', '~}', (pHash, pData) =>
		{
			// if there is a custom placeholder, use it
			if (typeof pData.PictForm.Placeholder !== 'undefined')
			{
				return `${pData.PictForm.Placeholder}`;
			}
			// or if there is a predefined placeholder, use it
			else
			{
				switch (pData.PictForm.InputType || pData.DataType)
				{
				case 'String':
				case 'TextArea':
					return 'Enter text...';
				case 'Number':
					return '0';
				case 'Option':
				case 'Select':
				case 'Select2':
				case 'Select2Multiple':
					return 'Select...';
				case 'DateTime':
				case 'DateTimePicker':
					return 'Select date/time...';
				case 'Date':
				case 'DatePicker':
					return 'Select date...';
				case 'Time':
				case 'TimePicker':
					return 'Select time...';
				case 'PhoneNumber':
					return '(555) 555-5555';
				case 'EmailAddress':
					return 'yourname@domain.com';
				case 'StreetAddress':
					return '1234 West St.';
				case 'Station':
					return 'station (ex. 23+07)';
				default:
					return '';
				}
			}
		});

		// balance the columns based on the width set in the configuration
		this.pict.MetaTemplate.addPattern('{~ColumnWidth:', '~}', (pHash, pData) =>
		{
			let tmpClasses = '';
			const tmpResponsive = this.pict.providers.ResponsiveUIAdjustmentProvider;
			const tmpRowWidths = tmpResponsive ? tmpResponsive.getProportionalRowWidths(pData) : null;
			if (tmpRowWidths)
			{
				if (tmpRowWidths.Auto)
				{
					return '';
				}
				// a layout-excluded column (explicit zero width / hidden input) must take no horizontal space
				if (tmpRowWidths.Excluded)
				{
					// close the class attribute and open a style attribute
					return `" style="display:none;`;
				}
				return tmpRowWidths.Classes;
			}
			// other apps, and rows outside a Record layout: the per-field Bulma classes
			if (pData.PictForm.Width)
			{
				const tmpWidth = parseFloat(pData.PictForm.Width);
				if (tmpWidth > 0 && tmpWidth <= 12)
				{
					tmpClasses = `is-${tmpWidth}`;
				}
				// if there is a width offset set, add it to the classes
				if (pData.PictForm.WidthOffset)
				{
					const tmpWidthOffset = parseFloat(pData.PictForm.WidthOffset);
					if (tmpWidthOffset > 0 && tmpWidthOffset <= 12)
					{
						tmpClasses += ` is-offset-${tmpWidthOffset}`;
					}
				}
			}

			return tmpClasses;
		});

		this.pict.MetaTemplate.addPattern('{~FilterToggleHidden:', '~}', (pHash, pData) =>
		{
			// Visibility class for the inline "Show All" toggle — hidden unless the descriptor (or its config-map entry) enables it.
			return libFilterToggleUI.isToggleVisible(pData) ? '' : 'is-hidden';
		});

		this.pict.MetaTemplate.addPattern('{~FilterToggleDisabled:', '~}', (pHash, pData) =>
		{
			// Inert class for the inline "Show All" toggle on a read-only / disabled field — filtering a
			// picker whose value cannot change is wasted work, and a live-looking toggle implies otherwise.
			// The class is painted here so there is no enabled->disabled flash; _FilterToggleUI re-applies it
			// at input-initialize for descriptors disabled after render (e.g. DisabledOnceSaved).
			return libFilterToggleUI.isInputDisabled(pData) ? libFilterToggleUI.DISABLED_CLASS : '';
		});
		libFilterToggleUI.ensureFilterToggleCSS(this.pict);

		// support overcrowded columns for the row in the group
		this.pict.MetaTemplate.addPattern('{~ColumnsOvercrowded:', '~}', (pHash, pData) =>
		{
			// if there is a Bulma column class set, use it
			if (pData._OvercrowdedColumns)
			{
				// if the columns are overcrowded, return the class
				return pData._OvercrowdedColumns ? 'is-multiline' : '';
			}
			// otherwise, return an empty string
			return '';
		});

		// Lazily resolve and cache the group layout (Tabular | RecordSet | ...) on the input descriptor
		// so layout-aware macros below can branch on it without re-walking the data-context array.
		/**
		 * @param {any} pDataObject
		 * @param {Array<any>} pContext
		 * @returns {string | null | undefined}
		 */
		const resolveGroupLayout = (pDataObject, pContext) =>
		{
			if (!pDataObject?.PictForm) return undefined;
			if (pDataObject.PictForm._GroupLayout !== undefined) return pDataObject.PictForm._GroupLayout;
			if (!Array.isArray(pContext)) return undefined;
			const tmpView = pContext.find((pEntry) => pEntry && typeof pEntry.getGroup === 'function');
			const tmpGroupIndex = pDataObject.PictForm.GroupIndex;
			if (tmpView && tmpGroupIndex !== undefined)
			{
				const tmpGroup = tmpView.getGroup(tmpGroupIndex);
				pDataObject.PictForm._GroupLayout = tmpGroup?.Layout || null;
			}
			else
			{
				pDataObject.PictForm._GroupLayout = null;
			}
			return pDataObject.PictForm._GroupLayout;
		};

		/**
		 * @param {string} pAlignment - Left, Center or Right, any case
		 * @returns {string} The Bulma text-alignment class, or '' when unrecognized
		 */
		const getAlignmentClass = (pAlignment) =>
		{
			switch (String(pAlignment).toLowerCase())
			{
			case 'left':
				return 'has-text-left';
			case 'center':
				return 'has-text-centered';
			case 'right':
				return 'has-text-right';
			default:
				return '';
			}
		};

		// Templates whose values right-align by default. Matched against the template PSF actually resolves
		// for the descriptor (InputType first, then DataType), so cells and tabular headers can't disagree.
		const RIGHT_ALIGNED_TEMPLATE_POSTFIXES = [ '-Input-DataType-Number', '-Input-DataType-PreciseNumber', '-Input-InputType-PreciseNumberReadOnly', '-Input-InputType-UpdateAwareNumber' ];

		/**
		 * @param {any} pData - The input descriptor
		 * @param {Array<any>} pContext
		 * @returns {boolean}
		 */
		const isRightAlignedByDefault = (pData, pContext) =>
		{
			const tmpView = Array.isArray(pContext) ? pContext.find((pEntry) => pEntry && typeof pEntry.checkThemeSpecificTemplate === 'function') : undefined;
			const tmpTemplateHash = (tmpView && this.pict.providers.DynamicInput) ? this.pict.providers.DynamicInput.getInputTemplateHash(tmpView, pData) : false;
			if (typeof tmpTemplateHash === 'string')
			{
				return RIGHT_ALIGNED_TEMPLATE_POSTFIXES.some((pPostfix) => tmpTemplateHash.endsWith(pPostfix));
			}
			if (pData.PictForm.InputType)
			{
				return RIGHT_ALIGNED_TEMPLATE_POSTFIXES.includes(`-Input-InputType-${pData.PictForm.InputType}`);
			}
			return RIGHT_ALIGNED_TEMPLATE_POSTFIXES.includes(`-Input-DataType-${pData.DataType}`);
		};

		/**
		 * @param {any} pData - The input descriptor
		 * @param {Array<any>} pContext
		 * @returns {string} The alignment class for the input's value
		 */
		const getColumnAlignmentClass = (pData, pContext) =>
		{
			// Numbers stay right even with a ColumnAlignment: CSV-imported manifests carry a blanket "left" on every field.
			if (isRightAlignedByDefault(pData, pContext))
			{
				return 'has-text-right';
			}
			if (pData.PictForm.ColumnAlignment)
			{
				return getAlignmentClass(pData.PictForm.ColumnAlignment);
			}
			// Boolean checkbox cells are usually narrow single-checkbox columns — center in plain Tabular,
			// left everywhere else (standard, vertical, RecordSet)
			if (pData.PictForm.InputType === 'Boolean')
			{
				return resolveGroupLayout(pData, pContext) === 'Tabular' ? 'has-text-centered' : 'has-text-left';
			}
			return '';
		};

		// support column alignment for the input value
		this.pict.MetaTemplate.addPattern('{~ColumnAlignment:', '~}', (/** @type {string} */ _pHash, /** @type {any} */ pData, /** @type {Array<any>} */ pContext) =>
		{
			return getColumnAlignmentClass(pData, pContext);
		});

		// field labels align only when the descriptor opts in with PictForm.LabelAlignment
		this.pict.MetaTemplate.addPattern('{~LabelAlignment:', '~}', (/** @type {string} */ _pHash, /** @type {any} */ pData) =>
		{
			return pData.PictForm.LabelAlignment ? getAlignmentClass(pData.PictForm.LabelAlignment) : '';
		});

		// tabular column headers follow their column's values unless the descriptor sets PictForm.LabelAlignment
		this.pict.MetaTemplate.addPattern('{~TabularHeaderAlignment:', '~}', (/** @type {string} */ _pHash, /** @type {any} */ pData, /** @type {Array<any>} */ pContext) =>
		{
			if (pData.PictForm.LabelAlignment)
			{
				return getAlignmentClass(pData.PictForm.LabelAlignment);
			}
			return getColumnAlignmentClass(pData, pContext);
		});

		// build help text content for vertical forms
		this.pict.MetaTemplate.addPattern('{~SelectOnFocus:', '~}', (pHash, pData) =>
		{
			return `onfocus="this.select();"`;
		});

		// NOTE: These are duplicated in the Panels, but we need them here for the form too.
		// TODO: Determine if we can remove the duplication with a Utility-like meta template collection
		// add the ".is-hidden" class to the element if the passed value is true
		this.pict.MetaTemplate.addPattern('{~HideContent:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			return (tmpDataObject.Content || tmpDataObject.Default) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the element if the passed value is false
		this.pict.MetaTemplate.addPattern('{~ShowContent:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			return (tmpDataObject.Content || tmpDataObject.Default) ? '' : 'is-hidden';
		});

		// add the ".is-hidden-tablet" class to the input label if PictForm.HideLabel is set
		// NOTE: Mobile devices keep the label, as it's needed for context in a stacked layout
		this.pict.MetaTemplate.addPattern('{~HideLabel:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			const hideLabel = tmpDataObject?.PictForm?.hasOwnProperty('HideLabel') && tmpDataObject?.PictForm?.HideLabel;
			return hideLabel ? 'is-hidden-tablet' : '';
		});

		// For Boolean inputs in a RecordSet layout, hide the cell-prefix "header" label since the checkbox template
		// renders its own inline label. Use "is-invisible" (preserves space) when sibling labels are visible so
		// row alignment matches; collapse fully ("is-hidden") only if PictForm.HideLabel is also set.
		this.pict.MetaTemplate.addPattern('{~HideCheckboxCellLabel:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			if (tmpDataObject?.PictForm?.InputType !== 'Boolean') return '';
			if (resolveGroupLayout(tmpDataObject, pContext) !== 'RecordSet') return '';
			return tmpDataObject.PictForm.HideLabel ? 'is-hidden' : 'is-invisible';
		});

		// For Boolean inputs in a plain Tabular (non-RecordSet) layout, hide the inline checkbox label since
		// the Tabular column header already labels the field — keep visible in RecordSet (no column header there).
		this.pict.MetaTemplate.addPattern('{~HideCheckboxInlineLabel:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			if (tmpDataObject?.PictForm?.InputType !== 'Boolean') return '';
			return resolveGroupLayout(tmpDataObject, pContext) === 'Tabular' ? 'is-hidden' : '';
		});

		// Geolocation input types have two presentations — the full picker (address search + editable
		// lat/long + readout + labeled buttons) and a compact readout bar whose picker lives in an Edit
		// modal. Rather than emit both and hide one, this macro picks the presentation and renders just
		// that body, so ids stay unique and no dead chrome ships in every tabular row. The tag carries
		// the theme (`{~GeolocationBody:Edit~}`); everything else comes off the input descriptor.
		//
		// Full size is the default everywhere and PictForm.Compact opts in — EXCEPT a Tabular table,
		// which is always compact because a full picker cannot fit a table cell. A Record Set stacks its
		// records, so it honors the flag exactly like a Standard field does.
		this.pict.MetaTemplate.addPattern('{~GeolocationBody:', '~}', (pHash, pData, pContext) =>
		{
			const tmpTabular = !!pData?.IsTabular;
			const tmpCompact = (resolveGroupLayout(pData, pContext) === 'Tabular') || !!pData?.PictForm?.Compact;
			const tmpBody = libGeolocationBodies.buildGeolocationBody(
				{
					Theme: `${pHash}`.trim(),
					Compact: tmpCompact,
					HasMap: pData?.PictForm?.InputType === 'GeolocationSelectorWithMap',
					Tabular: tmpTabular,
				});
			// Resolve the body's own tags against this same record + context (the macro output is not
			// re-parsed by the engine).
			return this.pict.parseTemplate(tmpBody, pData, null, pContext);
		});

		// Diagram / RichText editor body. Emits the inline View/Edit presentation for the theme the tag
		// carries (`{~EditorBody:Edit~}`); the InputType comes off the record. Like the geolocation macro,
		// the emitted body still contains {~D:...~} tags, so it is parsed here against the same record.
		this.pict.MetaTemplate.addPattern('{~EditorBody:', '~}', (pHash, pData, pContext) =>
		{
			const tmpBody = libEditorBodies.buildEditorBody(
				{
					Theme: `${pHash}`.trim(),
					InputType: pData?.PictForm?.InputType,
				});
			return this.pict.parseTemplate(tmpBody, pData, null, pContext);
		});

		// add the ".is-hidden" class to the group title if the passed value is false
		this.pict.MetaTemplate.addPattern('{~ShowGroupTitle:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			// if the value is set to false, we should hide the title (this is visible by default if not set)
			return (tmpDataObject.hasOwnProperty('ShowTitle') && !tmpDataObject.ShowTitle) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the section title if the passed value is false
		this.pict.MetaTemplate.addPattern('{~ShowSectionTitle:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			// if the value is set to false, we should hide the title (this is visible by default if not set)
			return (tmpDataObject.hasOwnProperty('ShowTitle') && !tmpDataObject.ShowTitle) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to a section or group title when ShowTitleInPDF is false; only the Print theme templates use it
		this.pict.MetaTemplate.addPattern('{~ShowTitleInPDF:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			return (tmpDataObject?.hasOwnProperty('ShowTitleInPDF') && !tmpDataObject.ShowTitleInPDF) ? 'is-hidden' : '';
		});

		// add the ".is-hidden" class to the input if the passed value is true
		this.pict.MetaTemplate.addPattern('{~HideInPDF:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			let tmpHideFlag = false;
			// input level
			if (tmpDataObject?.hasOwnProperty('PictForm') && tmpDataObject.PictForm && tmpDataObject.PictForm?.hasOwnProperty('InputExtra') && tmpDataObject.PictForm.InputExtra)
			{
				tmpHideFlag = tmpDataObject.PictForm?.InputExtra?.trim().toLowerCase() === 'hide in pdf';
			}
			// group level
			else if (tmpDataObject?.hasOwnProperty('GroupExtra') && tmpDataObject.GroupExtra)
			{
				tmpHideFlag = tmpDataObject?.GroupExtra?.trim().toLowerCase() === 'hide in pdf';
			}
			// section level
			else if (tmpDataObject?.hasOwnProperty('SectionExtra') && tmpDataObject.SectionExtra)
			{
				tmpHideFlag = tmpDataObject?.SectionExtra?.trim().toLowerCase() === 'hide in pdf';
			}
			return tmpHideFlag ? 'is-hidden' : '';
		});

		// emit target/rel on Link anchors when the descriptor opts in via PictForm.LinkTarget
		this.pict.MetaTemplate.addPattern('{~LinkTarget:', '~}', (pHash, pData, pContext) =>
		{
			return libLinkTarget.resolveLinkTargetAttributes(this.pict.resolveStateFromAddress(pHash, pData, pContext));
		});

		this.pict.MetaTemplate.addPattern('{~HiddenInputTabularAdjustment:', '~}', (pHash, pData, pContext) =>
		{
			const tmpDataObject = this.pict.resolveStateFromAddress(pHash, pData, pContext);
			// if the input is hidden in a tabular context, we need to add a placeholder to maintain alignment
			// keep in step with addHiddenInputColumns in PictProvider-Bulma-TableControls.js: the colgroup must skip the same columns
			if (tmpDataObject.PictForm?.InputType === 'Hidden' && pData.IsTabular)
			{
				return `is-hidden`;
			}
			return '';
		});

		// human readable count summaries
		this.pict.addTemplate(require('./providers/PictProvider-Template-HumanCount.js'));
	}
}

module.exports = HeadlightDynamicInputsBundle;
